module.exports = __webpack_public_path__ + "img/delete.f8bc7959.svg";